import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import config from '../../config/config'

// Define a service using a base URL and expected endpoints
export const quizApi = createApi({
  reducerPath: 'quizApi',
  baseQuery: fetchBaseQuery(
    {
      baseUrl: config.baseUrl,
      prepareHeaders: (headers, { getState }) => {
        const token: string = (getState() as any)?.authentication?.token
        headers.set('Accept', 'application/json')
        headers.set('account', config.getAccountSlug())
        headers.set('authorization', `Bearer ${token}`)
        return headers
      }
    }
  ),
  endpoints: (builder) => ({
    getCurrentAttempt: builder.query({
      query: () => ({
        method: 'GET',
        url: 'quiz/attempts/current'
      })
    })
  })
})

export const { useGetCurrentAttemptQuery } = quizApi

// https://medium.com/@prashanta0234/using-axios-instance-with-interceptors-in-redux-toolkit-query-rtk-query-a4111eab5eaa
